export default "__VITE_ASSET__Dpi91nNL__"